import { Validator, AbstractControl, ValidationErrors, NG_VALIDATORS } from '@angular/forms';
import { Directive } from '@angular/core';


@Directive({
  selector:'[isValidEmail]',
  providers:[{
    provide:NG_VALIDATORS,
    multi:true,
    useExisting:IsValidEmail
  }]
})
export class IsValidEmail implements Validator{
  validate(control: AbstractControl):null|{[key:string]:string}{
    const value:string=control.value
    if(value){
      if(value.match(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/gi)) return null
      else return {invalidEmail:'email is invalid'}
    }
  }

}
